import {Tone} from "../../../../components/kit";

/** Estados SEPA en pantalla (#13893): los valores del API vienen en mayúsculas. */
export const MANDATE_STATUS: Record<string, { label: string, tone: Tone }> = {
	ACTIVO: {label: "Activo", tone: "success"},
	REVOCADO: {label: "Revocado", tone: "neutral"},
	CADUCADO: {label: "Caducado", tone: "warning"},
};

export const REMITTANCE_STATUS: Record<string, { label: string, tone: Tone }> = {
	BORRADOR: {label: "Borrador", tone: "warning"},
	PRESENTADA: {label: "Presentada", tone: "success"},
};
